<template>
  <div :class="classes">
    <div :class="roboClasses">
        <div :class="$style.robotWrap">
        <div ref="robot"></div>
      </div>
      <Hint :class="$style.hint" :position="position">
        <h1>{{ title }}</h1>
        <p>{{ text }}</p>
        <Button @click="stop" :class="$style.button" wide>
          Продолжить
        </Button>
      </Hint>
    </div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
import classes from '@/utils/classes'

import Button from '@/components/@ui/Button/Button.vue'
import Hint from '@/components/@ui/Hint/Hint.vue'

export default {
  name: 'Robo',
  props: {
    position: String, // left or right
    text: String,
    title: String,
    level: Number,
    winAnimation: Object,
    failAnimation: Object,
  },
  components: { Button, Hint },
  computed: {
    classes() {
      const { $style, active } = this
      return classes($style.wrapper, active && $style.active)
    },
    roboClasses() {
      const { $style, position, level } = this
      return classes(
        $style.robo,
        position === 'left' && $style.left,
        position === 'right' && $style.right,
        level && $style[`level-${level}`],
      )
    },
  },
  watch: {

  },
  methods: {
    run(win = false) {
      const animation = win ? this.winAnimation : this.failAnimation
      this.loadAnimation({ animation })

      if (win) {
        setTimeout(() => { this.active = true }, 1000)
      } else {
        setTimeout(() => { this.lottie.stop() }, 3000)
      }
    },
    stop() {
      this.active = false
      this.$emit('stop')

      this.lottie.stop()
    },
    loadAnimation({ animation, autoplay = true }) {
      if (this.lottie) {
        this.lottie.destroy()
      }

      this.lottie = lottie.loadAnimation({
        container: this.$refs.robot,
        renderer: 'svg',
        loop: true,
        autoplay,
        animationData: animation,
      })
    },
  },
  mounted() {
    this.loadAnimation({ animation: this.winAnimation, autoplay: false })
  },
  data: () => ({
    active: false,
  }),
}
</script>
<style lang="scss" module>
@import './Robo.scss';
</style>
